import {
  REVIEWABLE_DOCUMENT_CATEGORIES,
  REVIEWABLE_DOCUMENT_TYPES,
  ReviewableDocumentCategoryKey,
  ReviewableDocumentInput,
  ReviewableDocumentTypeKey,
} from '@bordrio/shared';
import { DeepPartial } from 'react-hook-form';
import {
  NifOrderFragment,
  ReviewableDocumentFragment,
} from '@src/generated/graphql';

export function extractReviewableDocumentInputFromNifOrder(
  order: NifOrderFragment | null | undefined,
  categoryKey: ReviewableDocumentCategoryKey,
  defaultTypeKey: ReviewableDocumentTypeKey,
  parentId?: string,
): DeepPartial<ReviewableDocumentInput> {
  const document = order?.intakeDocuments.find(
    (doc) =>
      REVIEWABLE_DOCUMENT_CATEGORIES[categoryKey].id ===
        doc.documentCategoryId &&
      (!parentId || doc.parentId === parentId),
  );
  if (!document) {
    const typeId = REVIEWABLE_DOCUMENT_TYPES[defaultTypeKey].id;
    return {
      currentVersion: {
        documentTypeId: typeId,
      },
    };
  }
  const currentVersion = document.reviewableDocument.currentVersion;
  return {
    id: document.id,
    currentVersion: currentVersion
      ? {
          documentTypeId: currentVersion.documentType.id,
          fileOne: currentVersion.fileOne,
          fileTwo: currentVersion.fileTwo,
        }
      : undefined,
  };
}

export function extractReviewableDocumentInputFromDocument(
  document: ReviewableDocumentFragment,
): DeepPartial<ReviewableDocumentInput> {
  const currentVersion = document.currentVersion;
  if (!currentVersion) {
    const firstValidType = Object.values(REVIEWABLE_DOCUMENT_TYPES).find(
      (type) => type.categories.includes(document.categoryId),
    );
    if (!firstValidType) {
      throw new Error(
        `No valid document type found for category ${document.categoryId}`,
      );
    }
    return {
      id: document.id,
      currentVersion: {
        documentTypeId: document.documentTypeId ?? firstValidType.id,
      },
    };
  }
  if (currentVersion.reviews.some((r) => !r.isApproved)) {
    return {
      id: document.id,
      currentVersion: {
        documentTypeId: currentVersion.documentType.id,
      },
    };
  }
  return {
    id: document.id,
    currentVersion: {
      documentTypeId: currentVersion.documentType.id,
      fileOne: currentVersion.fileOne,
      fileTwo: currentVersion.fileTwo,
    },
  };
}
